// gamesSeo.js — données SEO STATIQUES par jeu (indexation Google individuelle).
// Chaque jeu a sa propre page /jeu/<slug> avec titre + description + JSON-LD VideoGame uniques.
// Statique (pas de fetch) → robuste, lu par Googlebot qui exécute le JS. Le bouton « Jouer »
// utilise playUrl (host prod réel) ; GamePage tente aussi de rafraîchir via /games/:id (live).
// Garder aligné avec le catalogue backend (server.js) : mêmes id, mêmes hosts.

const GAMES_SEO = [
  {
    slug: 'vertivers',
    id: 5,
    name: 'VertiVers Battle',
    genre: 'Stratégie',
    playUrl: 'https://vertivers.vertingo.eu',
    image: '/images/games/worms-armageddon.png',
    tags: ['Tour par tour', 'Artillerie', 'Multijoueur', 'Classique'],
    net: 'Solo, hotseat local & en ligne (jusqu’à 4 joueurs)',
    seoTitle: 'VertiVers Battle — jeu d’artillerie tour par tour gratuit en ligne',
    seoDescription: 'Joue gratuitement à VertiVers Battle, un jeu d’artillerie tour par tour dans ton navigateur : commande ton escouade, maîtrise l’arsenal (bazooka, grenade, dynamite) et le terrain destructible. En solo, en local ou en ligne avec tes amis. Aucune installation.',
    intro: 'Un classique de l’artillerie au tour par tour, recréé en HTML5. Vise avec le vent, détruis le terrain et élimine l’équipe adverse.',
  },
  {
    slug: 'vertivers-2-5d',
    id: 13,
    name: 'VertiVers 2.5D',
    genre: 'Stratégie',
    playUrl: 'https://worms3d.vertingo.eu',
    image: '/images/games/worms-3d.png',
    tags: ['Tour par tour', 'Artillerie', '2.5D', 'Fait maison'],
    net: 'Solo, local & en ligne (duel)',
    seoTitle: 'VertiVers 2.5D — jeu d’artillerie 2.5D maison gratuit (Three.js)',
    seoDescription: 'VertiVers 2.5D, le jeu d’artillerie maison de VertinGo en 2.5D (Three.js) : combat au tour par tour sur terrain destructible, arsenal complet, saut, vent, caisses de ravitaillement et eau qui monte. Jouable gratuitement dans le navigateur, en solo ou en ligne.',
    intro: 'Notre jeu d’artillerie maison en 2.5D : relief, vent, eau qui monte à chaque round et une carte spéciale en forme du logo VertinGo.',
  },
  {
    slug: 'medieval',
    id: 4,
    name: 'Medieval RPG',
    genre: 'RPG',
    playUrl: 'https://medieval-game.vertingo.eu',
    image: '/images/games/medieval.png',
    tags: ['Médiéval', 'RPG', 'Multijoueur', 'Aventure'],
    net: 'En ligne — monde multijoueur',
    seoTitle: 'Medieval RPG — jeu de rôle médiéval multijoueur gratuit en ligne',
    seoDescription: 'Medieval RPG : un jeu de rôle médiéval multijoueur jouable gratuitement dans le navigateur. Explore un monde 2D en temps réel, combats des monstres, récolte des ressources et progresse avec d’autres joueurs. Aucune installation.',
    intro: 'Un monde médiéval 2D en ligne : explore, combats, récolte et progresse aux côtés d’autres joueurs en temps réel.',
  },
  {
    slug: 'blast-arena',
    id: 14,
    name: 'Blast Arena',
    genre: 'Arcade',
    playUrl: 'https://blast-arena-game.vertingo.eu',
    image: '/images/games/blast-arena.png',
    tags: ['Multijoueur', 'Battle Royale', 'Temps réel', 'Manette'],
    net: 'En ligne — jusqu’à 4 joueurs',
    seoTitle: 'Blast Arena — battle royale de bombes multijoueur gratuit en ligne',
    seoDescription: 'Blast Arena : un battle royale de bombes en ligne, jusqu’à 4 joueurs en temps réel sur des arènes rétro. 27 personnages, power-ups, support manette et tactile. Défie tes amis ou des joueurs du monde entier, gratuitement dans le navigateur.',
    intro: 'Battle royale de bombes en temps réel : pose tes bombes, ramasse des power-ups et sois le dernier debout, jusqu’à 4 joueurs.',
  },
  {
    slug: 'bomberman',
    id: 1,
    name: 'Bomberman Multiplayer',
    genre: 'Arcade',
    playUrl: 'https://bomberman-game.vertingo.eu',
    image: '/images/games/bomberman.png',
    tags: ['Multijoueur', 'Classique', 'Temps réel'],
    net: 'Solo & local',
    seoTitle: 'Bomberman Multiplayer — jeu de bombes arcade gratuit en ligne',
    seoDescription: 'Le grand classique arcade des bombes, réinventé pour le navigateur : pose des bombes, détruis les murs, ramasse des power-ups et élimine tes adversaires. Jouable gratuitement, sans installation.',
    intro: 'Le classique du jeu de bombes : détruis les murs, ramasse des power-ups et piège tes adversaires.',
  },
  {
    slug: 'dbz-fighting',
    id: 2,
    name: 'DBZ Fighting Game',
    genre: 'Combat',
    playUrl: 'https://dbz-game.vertingo.eu',
    image: '/images/games/dbz.svg',
    tags: ['Combat 2D', 'Anime', 'PvP', 'Duel'],
    net: 'Solo, local & duel en ligne',
    seoTitle: 'DBZ Fighting Game — jeu de combat 2D anime gratuit en ligne',
    seoDescription: 'Un jeu de combat 2D nerveux inspiré de Dragon Ball Z : choisis ton guerrier, enchaîne les combos et déclenche des attaques spéciales dévastatrices en duel. Gratuit, dans le navigateur, en solo ou en ligne.',
    intro: 'Combat 2D inspiré de Dragon Ball Z : combos, attaques spéciales et duels intenses au corps à corps.',
  },
  {
    slug: 'world-conquest',
    id: 8,
    name: 'World Conquest RTS',
    genre: 'Stratégie',
    playUrl: 'https://world-conquest-game.vertingo.eu',
    image: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=600&q=80',
    tags: ['RTS', 'Base building', 'Conquête', 'Temps réel'],
    net: 'En ligne',
    seoTitle: 'World Conquest — jeu de stratégie temps réel (RTS) gratuit en ligne',
    seoDescription: 'World Conquest : de la stratégie en temps réel dans le navigateur. Construis ta base, récolte des ressources, entraîne tes armées et conquiers la carte du monde. Gratuit, sans installation, joue directement en ligne.',
    intro: 'Stratégie en temps réel : construis ta base, gère ton économie, lève une armée et conquiers la carte.',
  },
  {
    slug: 'calcul-integral',
    id: 12,
    name: 'Calcul Intégral (WASM)',
    genre: 'Éducation',
    playUrl: 'https://calcul-integ.vertingo.eu',
    image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=600&q=80',
    tags: ['Maths', 'WebAssembly', 'C/SDL2', 'Fait maison'],
    net: 'Outil solo',
    seoTitle: 'Calcul Intégral — outil de maths WebAssembly gratuit (intégrales, vecteurs)',
    seoDescription: 'Calcul Intégral, un outil de maths maison signé VertinGo, codé en C/C++ SDL2 et compilé en WebAssembly : intégrales, calcul vectoriel, tir balistique, PGCD, binôme de Newton, coefficients de Bézout, tableaux de variation. À la vitesse native, directement dans le navigateur.',
    intro: 'Un outil de maths natif compilé en WebAssembly : intégrales, calcul vectoriel, balistique, PGCD, Newton, Bézout, tableaux de variation.',
  },
];

export const GAMES_SEO_BY_SLUG = GAMES_SEO.reduce((m, g) => { m[g.slug] = g; return m; }, {});
export default GAMES_SEO;
